module.exports = __webpack_public_path__ + "static/assets/b35d2b90f81b498c4d9ef92b53ad8a82.png";